import { render, staticRenderFns } from "./AiTaggingIconPopoverHost.vue?vue&type=template&id=7706b816&scoped=true"
import script from "./AiTaggingIconPopoverHost.vue?vue&type=script&lang=ts"
export * from "./AiTaggingIconPopoverHost.vue?vue&type=script&lang=ts"
import style0 from "./AiTaggingIconPopoverHost.vue?vue&type=style&index=0&id=7706b816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706b816",
  null
  
)

export default component.exports